import { render } from "./LineCardBig.vue?vue&type=template&id=5f84bff5&scoped=true"
import script from "./LineCardBig.vue?vue&type=script&lang=js"
export * from "./LineCardBig.vue?vue&type=script&lang=js"

import "./LineCardBig.vue?vue&type=style&index=0&id=5f84bff5&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f84bff5"]])

export default __exports__